<div class="bl-check-wrap bl-margin-top--4 bl-margin-bottom--8" [class.bl-disabled]="!field.enabled" [class.bl-required]="field.required" [ngClass]="formatter">
  <input
    class="bl-display--inline-block"
    type="checkbox"
    [attr.aria-describedby]="field.id+'-desc-container'"
    [attr.aria-labelledby]="fieldLabelledBy"
    [attr.data-automation-id]="field.automationId"
    [cuFieldState]="field"
    [disabled]="!field.enabled"
    [id]="field.id"
    [(ngModel)]="value"
    [required]="field.required"
    (click)= "onClick($event)"
  >
  <label class="bl-label bl-font-color--black bl-font-weight--600 bl-font-size--14" [for]="field.id" [id]="field.id + '-label'">
    {{ field.label }}
    <button *ngIf="field.config.tooltip" type="button" aria-label="tooltip" class="bl-font-color--blue bl-margin-left--4">
      <i class="cu-info-circle" eaTooltip="{{ field.config.tooltip }}"></i>
    </button>
  </label>
</div>
